import {
  setSidebarClose_actionType,
  setSidebarOpen_actionType,
  setSidebarToggle_actionType,
} from "../constants";

const initialState = {
  open: false,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case setSidebarOpen_actionType:
      return { ...state, open: true };
    case setSidebarClose_actionType:
      return { ...state, open: false };
    case setSidebarToggle_actionType:
      return { ...state, open: !state.open };
    default:
      return state;
  }
};

export default sidebarReducer;
